import classNames from "classnames";
import React from "react";
import { useLocation } from "react-router-dom";

import {
    authController,
    ChildAuthComponentProps,
} from "../../../../application/auth";
import ThrottleButton from "../../throttleButton";

const PasswordlessEmailConsumeLink: React.FC<ChildAuthComponentProps> = ({
  useErrorState,
}) => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const linkCode = queryParams.get("linkCode");
  const preAuthSessionId = queryParams.get("preAuthSessionId");
  const [, setErrorMessage] = useErrorState;

  const consumeCodeSubmit = async (event: React.FormEvent) => {
    try {
      event.preventDefault();

      await authController.consumeLinkCode(linkCode, preAuthSessionId);
    } catch (error: unknown) {
      if (error instanceof Error) {
        setErrorMessage(error.message);
      } else {
        setErrorMessage(error as string);
      }
    }
  };

  return (
    <div className="auth-form-container">
      <form className="auth-form">
        <div className="buttons">
          <ThrottleButton
            throttleTimeInMs={500}
            disabled={!linkCode || !preAuthSessionId}
            classList={classNames("primary-button")}
            type="submit"
            onClick={(e) => {
              window.history.replaceState(null, "", location.pathname);

              consumeCodeSubmit(e);
            }}
          >
            Submit One-Time Password (OTP)
          </ThrottleButton>
        </div>
      </form>
    </div>
  );
};

export default PasswordlessEmailConsumeLink;
